import { v1 as uuid } from 'uuid'
import store from 'store'
import i18n from 'i18n'
// redux imports
import { removeSystemNotification } from 'redux/Notifications'
import { updatePermissions } from 'redux/Config'
// module imports
import {
  contactSource,
  titleFromContact,
  titleFromCallDetails,
} from 'modules/Contact'
import { getPermission } from 'modules/Permissions'
// constant imports
import { NOTIFICATIONS, PROMPT } from 'constants/Permissions'
// asset imports
import icon from 'assets/images/icon.png'
import eventLogger from 'modules/Logger'

// need - incoming session, incoming caller / contact, country,
const notifySystemIncoming = async (id) => {
  eventLogger.info('NOTIFICATION:START')
  // verify permissions
  const { notifications } = store.getState().config.permissions
  // notification permissions not granted
  if (!notifications) {
    eventLogger.error('NOTIFICATION:NO_PERMISSION')
    return id
  }
  // notification permission needed
  if (notifications === PROMPT) {
    eventLogger.error('NOTIFICATION:IS_PROMPT')
    // get permission
    const name = NOTIFICATIONS
    const state = await getPermission(name)
    // update store
    store.dispatch(updatePermissions({ name, state }))
    // notification permissions not granted
    if (!state) {
      eventLogger.error('NOTIFICATION:PERMISSION_NOT_GRANTED')
      return id
    }
  }
  // get contact from incoming session or use provided contact object (for testing)
  const session = store.getState().sessions.list[id]
  const contact = session?.participant || id
  // create title
  const callDetailsTitle = titleFromCallDetails(contact)
  const title = `${i18n.t('NOTIFICATIONS.CALL_FROM')} ${
    callDetailsTitle || titleFromContact(contact)
  }`
  // TODO use this to chain a incoming to a missed call notification
  const tag = uuid()

  const options = {
    body: contactSource(contact),
    icon,
    // requireInteraction: true, // this would force the user to click
    tag,
  }

  eventLogger.info('NOTIFICATION:TITLE', title)
  eventLogger.info('NOTIFICATION:OPTIONS', options)

  const notification = new Notification(title, options)

  let clicked = false

  notification.onclick = () => {
    eventLogger.info('NOTIFICATION:ON_CLICK')
    clicked = true
    window.focus()
    notification.close()
    eventLogger.info('NOTIFICATION:REMOVE_FROM_CLICK')
    store.dispatch(removeSystemNotification())
  }

  notification.onclose = () => {
    eventLogger.info('NOTIFICATION:ON_CLOSE')
    if (!clicked) {
      eventLogger.info('NOTIFICATION:REMOVE_FROM_CLOSE')
      store.dispatch(removeSystemNotification())
    }
  }

  return id
}

export default notifySystemIncoming
